module.exports = __webpack_public_path__ + "img/no-icon.505e74f2.png";